import { atom, getDefaultStore } from "jotai"
import { createJSONStorage, atomWithStorage } from "jotai/utils"

type AuthTypeOld = {
	reportId: string
	key: string
}

const tryToMigrateOldAuth = (): AuthType => {
	const oldAuth = localStorage.getItem("auth")
	if (oldAuth) {
		try {
			const parsed = JSON.parse(oldAuth) as AuthTypeOld
			localStorage.removeItem("auth")
			if (!(parsed.reportId && parsed.key))
				return { currentReportId: "", reports: {} }

			return {
				currentReportId: parsed.reportId,
				reports: { [parsed.reportId]: parsed.key },
			}
		} catch (e) {}
	}
	return { currentReportId: "", reports: {} }
}

type ReportId = string
type Key = string

type AuthType = {
	currentReportId: ReportId
	reports: Record<ReportId, Key>
}

const storage = createJSONStorage<AuthType>(() => localStorage)

export const authAtom = atomWithStorage<AuthType>(
	"miles:auth",
	tryToMigrateOldAuth(),
	storage,
	{
		getOnInit: true,
	}
)

export function tryToTruncateUnusedReports(auth: AuthType): AuthType {
	if (Object.keys(auth.reports).length <= 30) return auth
	return {
		...auth,
		reports: {
			[auth.currentReportId]: auth.reports[auth.currentReportId],
		},
	}
}

export type CurrentAuth = {
	reportId: ReportId
	key: Key
}
export const currentAuthAtom = atom((get) => {
	const auth = get(authAtom)
	return {
		reportId: auth.currentReportId,
		key: auth.reports[auth.currentReportId],
	}
})

const store = getDefaultStore()

export const setKey = (reportId: ReportId, key: Key) => {
	store.set(authAtom, (auth) => ({
		...auth,
		reports: { ...auth.reports, [reportId]: key },
	}))
}

export const setCurrentReportId = (reportId: ReportId) => {
	store.set(authAtom, (auth) => ({
		...auth,
		currentReportId: reportId,
	}))
}
